import styles from './StatsCard.css'
import _ from 'lodash'
import cx from 'classnames'
import { YCard, YCardTitle } from '../../../Common/YCard'
import '../../../Common/SPTooltip.css'
import Popover from '../../../Common/Popover'

export const StatsCard = props => {
  const {
    title,
    titleContent,
    content,
    contentTitle,
    className
  } = props

  return (
    <YCard
      fluid
      className={cx(
        styles.statCard,
        { [className]: !!className }
      )}
    >
      <YCardTitle
        title={title}
        className={styles.statCardTitle}
      >
        {titleContent}
      </YCardTitle>
      {
        _.isEmpty(contentTitle)
          ? (
            <div className={styles.statCardItem}>
              {content}
            </div>
          )
          : (
            <Popover content={contentTitle}>
              <div className={styles.statCardItem}>
                {content}
              </div>
            </Popover>
          )
      }
    </YCard>
  )
}
